import { openNotification } from "./openNotification";
import {message} from "antd";

export const handleLimitedWebsiteAccessError = (errorData:any) => {
  if (errorData !== undefined && errorData.not_owned !== undefined){
    let messageText = errorData.not_owned;
    // openNotification('Error', message, 'OK', 'warn');
    message.error(messageText, 7);
  }
};